import React from "react";
import styled from "styled-components";
import { Radius, ZIndexes, background, prettyScrollbars } from "@glossy";
import { GlossyThemeProvider } from "@glossy";
import { Elevation } from "@glossy/elevations";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import Button from "@ui-kit/button";
import { Glyph } from "@ui-kit/icon";

interface IProps {
  icon?: Glyph;
  children: React.ReactNode;
  onOpenChange?: (open: boolean) => void;
  side?: "left" | "right" | "top" | "bottom";
}

const DropdownMenuArrow = styled(DropdownMenu.Arrow)`
  fill: ${background};
  line-height: 100%;
  margin: -1px;
`;

const Content = styled.div`
  position: relative;
  background-color: ${background};
  padding: 16px;
  border-radius: ${Radius.MediumLarge};
  box-shadow: ${Elevation.Elevation_3};
  max-height: 200px;
  ${prettyScrollbars()};
`;

const DropdownMenuContent = styled(DropdownMenu.Content)`
  z-index: ${ZIndexes.Modal};
  position: relative;
`;

const UiKitPopoverButton = ({
  icon = "circle-info",
  children,
  onOpenChange,
  side,
}: IProps) => (
  <GlossyThemeProvider name="surface">
    <DropdownMenu.Root modal={false} onOpenChange={onOpenChange}>
      <DropdownMenu.Trigger asChild>
        <Button icon={icon} variant="tertiary" size="xs" />
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenuContent side={side} collisionPadding={24}>
          <Content>{children}</Content>
          <DropdownMenuArrow />
        </DropdownMenuContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  </GlossyThemeProvider>
);

export default UiKitPopoverButton;
